import { useQuery } from '@tanstack/react-query'
import { fetchApiWithToken } from '~/api/utils'
import {
  type TaxonomyItems,
  type TaxonomySlug,
  taxonomyQueryStaleTime
} from '../types'

type UseTaxonomyOptions = {
  enabled?: boolean
  context?: 'applicant' | 'contact'
}

export const useTaxonomy = <S extends TaxonomySlug>(
  slug: S,
  options?: UseTaxonomyOptions
) =>
  useQuery({
    queryKey: ['taxonomy', slug, options?.context],
    queryFn: () =>
      fetchApiWithToken<TaxonomyItems<S>>({
        method: 'get',
        url: `/v1/taxonomies/${slug}?itemsPerPage=1000${options?.context ? `&context=${options.context}` : ''}`
      }),
    staleTime: taxonomyQueryStaleTime,
    enabled: options?.enabled ?? true
  })
